import {
  IEditCommand,
  EditCommandSet,
  IEditCommandFactory,
} from "./command";

export class EditCommandStore<T> implements IEditCommandFactory<T> {
  constructor(source: IEditCommand<T>[] | EditCommandStore<T>) {
    this._commands = (source instanceof EditCommandStore)
      ? source._commands
      : (source ? source : []);
  }

  private _commands: IEditCommand<T>[];

  protected registerCommand(command: IEditCommand<T>) {
    this._commands.push(command);
  }

  createCommand(): IEditCommand<T> {
    return (0 < this._commands.length)
      ? this.createCommandSet()
      : null;
  }

  private createCommandSet(): EditCommandSet<T> {
    // freezeされても大丈夫なようにメンバのインスタンスは変えない.
    const command = new EditCommandSet(this._commands.concat());
    this._commands.splice(0, this._commands.length);
    return command;
  }
}
